import { __awaiter } from '../_virtual/_tslib.js';
import { useVahakMutationQuery } from '../hooks/useVahakQueryClient.js';
import useVahakHttpClient from '../hooks/useVahakHttpClient.js';
import API from './const.js';
import { QueryNames } from './hooks/queryNames.js';
import { encryptData } from '../methods/encryptData.js';

var LoginScope;
(function (LoginScope) {
    LoginScope[LoginScope["LOGIN"] = 0] = "LOGIN";
    LoginScope[LoginScope["BOS"] = 1] = "BOS";
    LoginScope[LoginScope["ALT"] = 2] = "ALT";
    LoginScope[LoginScope["LOAD_VERIFICATION"] = 3] = "LOAD_VERIFICATION";
})(LoginScope || (LoginScope = {}));
function useSendOTP() {
    const { POST } = useVahakHttpClient();
    const sendOTP = ({ phoneNumber, scope, isWhatsApp = false }) => __awaiter(this, void 0, void 0, function* () {
        const config = {
            key: "bf2f88919c968dc2c50410f26444efe1",
            iv: "c50410f26444efe1"
        };
        const meta = encryptData({ phone_number: String(phoneNumber), time_stamp: Date.now(), source: "send_otp" }, config);
        return POST(API.OTP, {
            phone_number: String(phoneNumber),
            scope,
            request_meta_data: meta,
            is_whatsapp: isWhatsApp
        });
    });
    return useVahakMutationQuery(QueryNames.auth.sendOTP, sendOTP);
}

export { LoginScope, useSendOTP };
//# sourceMappingURL=sms.service.js.map
